import { insertAtCaret } from './insert-at-caret';

export { insertAtCaret }

window.insertAtCaret = insertAtCaret;
